import { combineReducers } from "redux";
import mapReducer from "./mapReducer";
import filterReducer from "./filterReducer";
import cartReducer from "./cartReducer";
import authReducer from "./authReducer";
import planoCampainsReducer from "./planoCampainsReducer";
import locateSitesReducer from "./locateSitesReducer";

export default combineReducers({
  map: mapReducer,
  filter: filterReducer,
  cart: cartReducer,
  auth: authReducer,
  planoCampaigns: planoCampainsReducer,
  locateSitesReducer : locateSitesReducer
});


// WEBPACK FOOTER //
// ./src/v3/reducers/index.js